import { useStore } from './use-store';
import { getRights, type IRights } from 'utils';

/** Базовый хук получения прав **/
export const useRights = (slug: string): IRights => {
  const { user } = useStore();

  return getRights(slug, user.permissions);
};
